import DataRoom from "components/global/DataRoom";

const BusinessDataRoom = () => <DataRoom documentBucket="businessDocuments" />

export default BusinessDataRoom;
